import React from 'react'
import Link from 'gatsby-link'
import { css } from 'emotion'
import styled from 'react-emotion'

import Section from '../components/section'

const FooterClass = css`
  clear: both;
  background-color: #00b386;
  display: flex;
  flex-direction: column-reverse;
  padding-bottom: 10rem;
  padding-top: 3rem;

  @media (min-width: 767px) {
    flex-direction: row;   
  }
`

const Nav = styled.div`
  display: flex;
  flex-direction: row;
  position:relative;
  z-index: 1;
  border-top: 1px solid white;
  padding-top: 1rem;

  @media (min-width: 767px) {
    border-top: none;
    padding-top: 0;    
  }
`

const NavList = styled.ul`
  list-style: none;
  padding: 0.5rem;
  font-size: 0.7rem;

  &:last-child {
    border: none;
  }

  @media (min-width: 767px) {
    padding: 1rem 2rem;
    border-right: 1px solid white;
    font-size: 1rem;
  }
`

const NavListItem = styled.li`
  color: white;
  margin-bottom: 1rem;
  font-weight: 300;

  a {
    color: white
  }
`

class Footer extends React.Component {
  shouldComponentUpdate() { return false; }
  render() {
    return (
      <footer>
        <Section className={FooterClass} shading>
          <Nav>
            <NavList>
              <NavListItem>
                <Link to={'/#partners'}>Partners</Link>
              </NavListItem>
              <NavListItem>
                <Link to={'/#how-it-works'}>How It Works</Link>
              </NavListItem>
              <NavListItem>
                <Link to={'/#features'}>Features</Link>
              </NavListItem>
              <NavListItem>
                <Link to={'/testimonials'}>Testimonials</Link>
              </NavListItem>
              <NavListItem>
                <Link to={'/press'}>Press</Link>
              </NavListItem>
              {/*<NavListItem>Blog</NavListItem>*/}
            </NavList>
            <NavList>
              <NavListItem>
                <Link to={'/blog'}>Blog</Link>
              </NavListItem>
              <NavListItem>
                <Link to={'/tos'}>Terms of Use</Link>
              </NavListItem>
              <NavListItem>
                <Link to={'/privacy'}>Privacy Policy</Link>
              </NavListItem>
            </NavList>
            <NavList>
              <NavListItem>Contact</NavListItem>
              <NavListItem>sales@trywhistle.com</NavListItem>
              <NavListItem>
                <div className="fb-messengermessageus" 
                  data-messenger_app_id={process.env.GATSBY_FACEBOOK_APPID} 
                  data-page_id={process.env.GATSBY_FACEBOOK_PAGEID}
                  data-color="white"
                  data-size="standard">
                </div>
              </NavListItem>
              <NavListItem>
                <div className="fb-like" data-href="https://www.facebook.com/trywhistle" 
                  data-width="79" data-layout="button_count" data-action="like" data-size="small" 
                  data-share="false">
                </div>
              </NavListItem>
              <NavListItem>
                <div>
                  <script type="IN/FollowCompany" data-id="4797522" data-counter="right"></script>
                </div>
              </NavListItem>
            </NavList>
          </Nav>
          <div>
            <div id="htr-widget-container-513"></div>
          </div>
        </Section>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js